import React, { useEffect, useRef } from 'react';

const InteractiveBg = () => {
  const canvasRef = useRef(null);
  const mouseRef = useRef({ x: -500, y: -500 });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let w, h, animId;

    const resize = () => {
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w;
      canvas.height = h;
    };
    resize();

    
    const miniCharts = [];
    const chartCount = 12;
    for (let i = 0; i < chartCount; i++) {
      const candles = [];
      let price = 50;
      for (let c = 0; c < 8; c++) {
        const open = price;
        price += (Math.random() - 0.5) * 15;
        const close = price;
        const high = Math.max(open, close) + Math.random() * 5;
        const low = Math.min(open, close) - Math.random() * 5;
        candles.push({ open, close, high, low, green: close > open });
      }
      miniCharts.push({
        x: Math.random() * w,
        y: Math.random() * h,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.2,
        candles,
        scale: 0.6 + Math.random() * 0.6,
        alpha: 0.06 + Math.random() * 0.06,
        phase: Math.random() * Math.PI * 2,
      });
    }

    
    const tickers = [];
    const tickerData = [
      'BTC 47,283', 'ETH 3,412', 'AAVE 152.4', 'DOGE 0.142',
      'EUR 1.084', 'ALGO 0.231', 'SOL 142.8', 'BNB 612.4'
    ];
    for (let i = 0; i < 15; i++) {
      tickers.push({
        x: Math.random() * w,
        y: Math.random() * h,
        vx: 0.2 + Math.random() * 0.5,
        text: tickerData[Math.floor(Math.random() * tickerData.length)],
        alpha: 0.04 + Math.random() * 0.05,
        fontSize: 9 + Math.floor(Math.random() * 3),
      });
    }

    
    const trendLines = [];
    for (let i = 0; i < 6; i++) {
      const pts = [];
      let py = Math.random() * h;
      for (let p = 0; p <= 30; p++) {
        py += (Math.random() - 0.5) * 8;
        pts.push(py);
      }
      trendLines.push({
        startX: -100 - Math.random() * 300,
        y: 0,
        points: pts,
        speed: 0.3 + Math.random() * 0.5,
        alpha: 0.04 + Math.random() * 0.04,
        baseY: Math.random() * h,
        color: Math.random() > 0.3 ? '56,254,96' : '255,82,82',
      });
    }

    
    const gridSpacing = 100;
    const gridNodes = [];
    for (let gy = 0; gy < h + gridSpacing; gy += gridSpacing) {
      for (let gx = 0; gx < w + gridSpacing; gx += gridSpacing) {
        gridNodes.push({
          x: gx, y: gy,
          baseX: gx, baseY: gy,
          phase: Math.random() * Math.PI * 2,
        });
      }
    }

    const handleMouse = (e) => {
      mouseRef.current = { x: e.clientX, y: e.clientY };
    };

    let time = 0;

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      time += 0.005;
      const mouse = mouseRef.current;
      const mouseRadius = 180;

      
      gridNodes.forEach(node => {
        node.x = node.baseX + Math.sin(time * 2 + node.phase) * 2;
        node.y = node.baseY + Math.cos(time * 1.5 + node.phase) * 2;

        
        const dx = node.x - mouse.x;
        const dy = node.y - mouse.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < mouseRadius && dist > 0) {
          const force = (1 - dist / mouseRadius) * 12;
          node.x += (dx / dist) * force;
          node.y += (dy / dist) * force;
        }
      });

      
      const gridCols = Math.ceil(w / gridSpacing) + 1;
      for (let i = 0; i < gridNodes.length; i++) {
        const a = gridNodes[i];
        
        if ((i + 1) % gridCols !== 0 && i + 1 < gridNodes.length) {
          const b = gridNodes[i + 1];
          const midDist = Math.sqrt(((a.x + b.x) / 2 - mouse.x) ** 2 + ((a.y + b.y) / 2 - mouse.y) ** 2);
          const boost = midDist < mouseRadius ? (1 - midDist / mouseRadius) * 0.08 : 0;
          ctx.strokeStyle = `rgba(56,254,96,${0.025 + boost})`;
          ctx.lineWidth = 0.5;
          ctx.beginPath();
          ctx.moveTo(a.x, a.y);
          ctx.lineTo(b.x, b.y);
          ctx.stroke();
        }
        
        if (i + gridCols < gridNodes.length) {
          const b = gridNodes[i + gridCols];
          const midDist = Math.sqrt(((a.x + b.x) / 2 - mouse.x) ** 2 + ((a.y + b.y) / 2 - mouse.y) ** 2);
          const boost = midDist < mouseRadius ? (1 - midDist / mouseRadius) * 0.08 : 0;
          ctx.strokeStyle = `rgba(56,254,96,${0.025 + boost})`;
          ctx.lineWidth = 0.5;
          ctx.beginPath();
          ctx.moveTo(a.x, a.y);
          ctx.lineTo(b.x, b.y);
          ctx.stroke();
        }
      }

      
      gridNodes.forEach(node => {
        const dist = Math.sqrt((node.x - mouse.x) ** 2 + (node.y - mouse.y) ** 2);
        if (dist < mouseRadius) {
          const a = (1 - dist / mouseRadius) * 0.35;
          ctx.fillStyle = `rgba(56,254,96,${a})`;
          ctx.beginPath();
          ctx.arc(node.x, node.y, 1.5 + (1 - dist / mouseRadius) * 2, 0, Math.PI * 2);
          ctx.fill();
        }
      });

      
      miniCharts.forEach(chart => {
        chart.x += chart.vx;
        chart.y += chart.vy + Math.sin(time * 2 + chart.phase) * 0.2;

        if (chart.x > w + 100) chart.x = -100;
        if (chart.x < -100) chart.x = w + 100;
        if (chart.y > h + 50) chart.y = -50;
        if (chart.y < -50) chart.y = h + 50;

        
        const dist = Math.sqrt((chart.x - mouse.x) ** 2 + (chart.y - mouse.y) ** 2);
        const mouseBoost = dist < mouseRadius ? (1 - dist / mouseRadius) * 0.08 : 0;
        const alpha = chart.alpha + mouseBoost;

        const s = chart.scale;
        const candleW = 4 * s;
        const chartW = chart.candles.length * (candleW + 2 * s);

        ctx.save();
        ctx.globalAlpha = alpha;
        chart.candles.forEach((c, ci) => {
          const cx = chart.x + ci * (candleW + 2 * s);
          const bodyTop = Math.min(c.open, c.close) * s * 0.5;
          const bodyBot = Math.max(c.open, c.close) * s * 0.5;
          const color = c.green ? '#38FE60' : '#ff5252';

          
          ctx.strokeStyle = color;
          ctx.lineWidth = 0.5;
          ctx.beginPath();
          ctx.moveTo(cx + candleW / 2, chart.y - c.high * s * 0.5);
          ctx.lineTo(cx + candleW / 2, chart.y - c.low * s * 0.5);
          ctx.stroke();

          
          ctx.fillStyle = color;
          ctx.fillRect(cx, chart.y - bodyBot, candleW, bodyBot - bodyTop || 1);
        });
        ctx.restore();
      });

      
      tickers.forEach(t => {
        t.x += t.vx;
        if (t.x > w + 100) {
          t.x = -80;
          t.y = Math.random() * h;
          t.text = tickerData[Math.floor(Math.random() * tickerData.length)];
        }

        const dist = Math.sqrt((t.x - mouse.x) ** 2 + (t.y - mouse.y) ** 2);
        const boost = dist < mouseRadius ? (1 - dist / mouseRadius) * 0.06 : 0;

        ctx.font = `${t.fontSize}px monospace`;
        ctx.fillStyle = `rgba(56,254,96,${t.alpha + boost})`;
        ctx.fillText(t.text, t.x, t.y);
      });

      
      trendLines.forEach(tl => {
        tl.startX += tl.speed;
        if (tl.startX > w + 100) {
          tl.startX = -100 - Math.random() * 300;
          tl.baseY = Math.random() * h;
          
          let py = 0;
          for (let p = 0; p < tl.points.length; p++) {
            py += (Math.random() - 0.5) * 8;
            tl.points[p] = py;
          }
          tl.color = Math.random() > 0.3 ? '56,254,96' : '255,82,82';
        }

        ctx.beginPath();
        ctx.strokeStyle = `rgba(${tl.color},${tl.alpha})`;
        ctx.lineWidth = 1;
        tl.points.forEach((py, pi) => {
          const px = tl.startX + pi * 15;
          const y = tl.baseY + py;
          if (pi === 0) ctx.moveTo(px, y);
          else ctx.lineTo(px, y);
        });
        ctx.stroke();
      });

      
      if (mouse.x > 0) {
        const g = ctx.createRadialGradient(mouse.x, mouse.y, 0, mouse.x, mouse.y, mouseRadius);
        g.addColorStop(0, 'rgba(56,254,96,0.04)');
        g.addColorStop(0.5, 'rgba(56,254,96,0.015)');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(mouse.x, mouse.y, mouseRadius, 0, Math.PI * 2);
        ctx.fill();
      }

      animId = requestAnimationFrame(draw);
    };

    draw();
    document.addEventListener('mousemove', handleMouse);
    window.addEventListener('resize', resize);

    return () => {
      cancelAnimationFrame(animId);
      document.removeEventListener('mousemove', handleMouse);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 z-0"
      style={{ pointerEvents: 'none', filter: 'blur(0.5px)', opacity: 0.8 }}
    />
  );
};

export default InteractiveBg;
